import React, { useState } from 'react';

const Rooms = () => {
  const [selectedRoom, setSelectedRoom] = useState('premium');
  
  const rooms = [
    {
      id: 'premium',
      title: 'Premium Rooms',
      description: 'Experience unmatched comfort and elegance in the Premium Rooms at Hotel Prakash Palace, Varanasi. Thoughtfully designed to cater to discerning travelers, our premium rooms offer a blend of luxury and convenience. Each room features modern amenities, including air conditioning, free Wi-Fi, flat-screen TVs, and plush bedding to ensure a restful stay.',
      image: 'https://www.hotelsmumbaiindia.com/images/hotelgallery/hotel-four-seasons-330.jpg',
      amenities: ['Air Conditioning', 'Free Wi-Fi', 'Flat-screen TV', 'Plush Bedding', 'Spacious Interior', '24-hour Room Service'],
      price: '₹8,999',
      images: [
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/557564924.jpg?k=1eccfac62d13892108570ea4d40072145a10762cc0cdc33856cc3810c9c3be8a&o=',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/557564924.jpg?k=1eccfac62d13892108570ea4d40072145a10762cc0cdc33856cc3810c9c3be8a&o=',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/557564924.jpg?k=1eccfac62d13892108570ea4d40072145a10762cc0cdc33856cc3810c9c3be8a&o='
      ]
    },
    {
      id: 'super-deluxe',
      title: 'Super Deluxe Rooms',
      description: 'Experience luxury and comfort in the Super Deluxe Rooms at Hotel Prakash Palace, Varanasi. Designed with elegance and equipped with modern amenities, these rooms offer a perfect retreat for travelers. Enjoy spacious interiors, premium bedding, air conditioning, free Wi-Fi, and a flat-screen TV for your convenience.',
      image: 'https://qtxasset.com/quartz/qcloud1/media/image/new-york-13-room-skyline-view.jpeg?VersionId=43XU6N68IRmUV7w9Ee2tgUBnm0uKpGAI',
      amenities: ['Air Conditioning', 'Free Wi-Fi', 'Flat-screen TV', 'Premium Bedding', 'Spacious Interior', 'Work Desk'],
      price: '₹6,999',
      images: [
        'https://qtxasset.com/quartz/qcloud1/media/image/new-york-13-room-skyline-view.jpeg?VersionId=43XU6N68IRmUV7w9Ee2tgUBnm0uKpGAI',
        'https://qtxasset.com/quartz/qcloud1/media/image/new-york-13-room-skyline-view.jpeg?VersionId=43XU6N68IRmUV7w9Ee2tgUBnm0uKpGAI',
        'https://qtxasset.com/quartz/qcloud1/media/image/new-york-13-room-skyline-view.jpeg?VersionId=43XU6N68IRmUV7w9Ee2tgUBnm0uKpGAI'
      ]
    },
    {
      id: 'deluxe',
      title: 'Deluxe Rooms',
      description: 'Experience unmatched comfort in the Deluxe Rooms at Hotel Prakash Palace, Varanasi. Designed with elegance and equipped with modern amenities, our rooms provide the perfect blend of luxury and convenience. Each room features premium bedding, air conditioning, free Wi-Fi, flat-screen TVs, and 24-hour room service to ensure a relaxing stay.',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2JCLcW4krPcW1JbkkVzdi2mtBKMchI28sFQ&s',
      amenities: ['Air Conditioning', 'Free Wi-Fi', 'Flat-screen TV', 'Premium Bedding', '24-hour Room Service', 'Complimentary Toiletries'],
      price: '₹4,999',
      images: [
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2JCLcW4krPcW1JbkkVzdi2mtBKMchI28sFQ&s',
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2JCLcW4krPcW1JbkkVzdi2mtBKMchI28sFQ&s',
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2JCLcW4krPcW1JbkkVzdi2mtBKMchI28sFQ&s'
      ]
    }
  ];

  const selectedRoomData = rooms.find(room => room.id === selectedRoom);

  return (
    <div className="min-h-screen bg-gray-50">
   

      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-amber-900 via-amber-800 to-amber-700 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Our Rooms</h2>
            <p className="text-lg text-amber-100 mb-8">Discover the perfect blend of luxury, comfort, and traditional hospitality at Hotel Prakash Palace. Each room is thoughtfully designed to provide an unforgettable experience in the spiritual city of Varanasi.</p>
          </div>
        </div>
        <div className="absolute top-0 right-0 h-full w-1/3 bg-gradient-to-l from-amber-900/30 to-transparent"></div>
      </div>

      <main className="container mx-auto px-4 py-12">
        {/* Room Selection Tabs */}
        <div className="flex flex-col md:flex-row justify-center mb-12 space-y-4 md:space-y-0 md:space-x-6">
          {rooms.map((room) => (
            <button
              key={room.id}
              className={`px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 transform hover:-translate-y-1 ${
                selectedRoom === room.id
                  ? 'bg-amber-800 text-white shadow-lg'
                  : 'bg-white text-amber-800 border-2 border-amber-200 hover:bg-amber-50'
              }`}
              onClick={() => setSelectedRoom(room.id)}
            >
              {room.title}
            </button>
          ))}
        </div>

        {/* Selected Room Details */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-16">
          <div className="md:flex">
            {/* Room Image Gallery */}
            <div className="md:w-1/2 p-6">
              <div className="rounded-xl overflow-hidden mb-4">
                <img 
                  src={selectedRoomData.image} 
                  alt={selectedRoomData.title}
                  className="w-full h-64 md:h-80 object-cover transition-transform duration-500 hover:scale-105"
                />
              </div>
              <div className="grid grid-cols-3 gap-3">
                {selectedRoomData.images.map((img, index) => (
                  <div key={index} className="rounded-lg overflow-hidden">
                    <img 
                      src={img} 
                      alt={`${selectedRoomData.title} view ${index + 1}`}
                      className="w-full h-24 object-cover transition-transform duration-300 hover:scale-110"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Room Information */}
            <div className="md:w-1/2 p-6 md:p-8">
              <div className="flex justify-between items-start mb-6">
                <h3 className="text-3xl font-bold text-gray-800">{selectedRoomData.title}</h3>
                <div className="text-right">
                  <div className="text-2xl font-bold text-amber-800">{selectedRoomData.price}</div>
                  <div className="text-gray-500">per night</div>
                </div>
              </div>
              
              <p className="text-gray-600 mb-8 leading-relaxed">{selectedRoomData.description}</p>
              
              <div className="mb-8">
                <h4 className="text-xl font-semibold text-gray-800 mb-4">Room Amenities</h4>
                <div className="grid grid-cols-2 gap-3">
                  {selectedRoomData.amenities.map((amenity, index) => (
                    <div key={index} className="flex items-center">
                      <svg className="w-5 h-5 text-amber-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span className="text-gray-700">{amenity}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              <button className="w-full bg-gradient-to-r from-amber-700 to-amber-600 hover:from-amber-800 hover:to-amber-700 text-white font-bold py-4 px-6 rounded-lg text-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl">
                Book Now - {selectedRoomData.price} per night
              </button>
              
              <div className="mt-4 text-center text-gray-500">
                <p>Free cancellation • No prepayment needed • Breakfast included</p>
              </div>
            </div>
          </div>
        </div>

        {/* All Rooms Overview */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-10">Explore All Room Types</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {rooms.map((room) => (
              <div 
                key={room.id} 
                className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2"
              >
                <div className="h-56 overflow-hidden">
                  <img 
                    src={room.image} 
                    alt={room.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-xl font-bold text-gray-800">{room.title}</h3>
                    <span className="text-amber-800 font-bold">{room.price}</span>
                  </div>
                  <p className="text-gray-600 mb-6 line-clamp-3">{room.description.substring(0, 150)}...</p>
                  <button 
                    onClick={() => setSelectedRoom(room.id)}
                    className="w-full py-3 bg-amber-100 hover:bg-amber-200 text-amber-800 font-semibold rounded-lg transition duration-300"
                  >
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="bg-gradient-to-r from-amber-800 to-amber-700 rounded-2xl p-8 md:p-12 text-white text-center">
          <h2 className="text-3xl font-bold mb-4">Ready for an Unforgettable Stay?</h2>
          <p className="text-xl text-amber-100 mb-8 max-w-2xl mx-auto">Book your luxurious room at Hotel Prakash Palace today and experience the perfect blend of comfort and traditional hospitality in Varanasi.</p>
          <button className="bg-white text-amber-800 hover:bg-amber-50 font-bold py-4 px-10 rounded-lg text-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl">
            Book Your Stay Now
          </button>
        </div>
      </main>

   
    </div>
  );
};

export default Rooms;